const ROUTE_LABELS: Record<
  string,
  {
    label: string;
    isHidden: boolean;
  }
> = {
  // Root routes
  '/': { label: 'Home', isHidden: false },
  '/dashboard': { label: 'Dashboard', isHidden: false },
  '/privacy-policy': { label: 'Privacy Policy', isHidden: false },
  '/terms-of-use': { label: 'Terms of Use', isHidden: false },
  '/support': { label: 'Support', isHidden: false },
  '/about': { label: 'About', isHidden: false },

  // Auth routes
  '/auth': { label: 'Authentication', isHidden: true },
  '/login': { label: 'Login', isHidden: false },
  '/register': { label: 'Register', isHidden: false },
  '/forgot-password': { label: 'Forgot Password', isHidden: false },
  '/verify': { label: 'Verify Account', isHidden: false },
  '/onboarding': { label: 'Onboarding', isHidden: true },

  // Account Settings routes
  '/account-settings': { label: 'Account Settings', isHidden: true },
  '/account-settings-tile': { label: 'Account Settings', isHidden: false },
  '/account-settings/profile': {
    label: 'Personal Information',
    isHidden: false,
  },
  '/account-settings/login-and-security': {
    label: 'Login & Security',
    isHidden: false,
  },
  '/delete-account': {
    label: 'Delete Account',
    isHidden: false,
  },
  '/change-password': {
    label: 'Change Password',
    isHidden: false,
  },
  '/change-email': {
    label: 'Change Email',
    isHidden: false,
  },

  // Help Centre routes
  '/account-settings/help-centre': {
    label: 'Help Centre',
    isHidden: false,
  },
  '/account-settings/help-centre/contact-us': {
    label: 'Contact Us',
    isHidden: false,
  },
  '/report-a-problem': {
    label: 'Report a Problem',
    isHidden: false,
  },

  // About routes
  '/account-settings/about': { label: 'About', isHidden: false },

  // Marketplace routes (if using the marketplace layer)
  '/marketplace': { label: 'Marketplace', isHidden: false },

  // Notifications routes (if using the notifications layer)
  '/notifications': { label: 'Notifications', isHidden: false },
};

export default ROUTE_LABELS;
